import { memo } from "react";
import { Link } from "react-router-dom";
import { MenuItem } from "react-pro-sidebar";
import LabelIcon from "@mui/icons-material/LabelOutlined";
import { useGetLabelsQuery } from "../../features/labels/labelsApiSlice";

function LabelsItem(props) {
  const { label } = useGetLabelsQuery("labelsList", {
    selectFromResult: ({ data }) => ({
      label: data?.entities[props.labelId],
    }),
  });
  return (
    <MenuItem
      component={
        <Link to={`/labels/${label.name}`} state={{ id: label._id }} />
      }
      icon={<LabelIcon />}
    >
      {label.name}
    </MenuItem>
  );
}

const memoizedLabelsItem = memo(LabelsItem);
//export default Note;
export default memoizedLabelsItem;
